import React, { Component } from "react";
import PropTypes from "prop-types";
import Layout from "../Layout";
import { Layout11 } from "../ContentBox";
import { DivHover, DivHelp } from "./styled";

class YoutubeView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hover: false
    };
  }
  onHover = () => {
    this.setState({ hover: true });
  };
  onMouseOver = () => {
    this.setState({ hover: false });
  };
  render() {
    return (
      <DivHover
        onMouseLeave={this.onMouseOver.bind(this)}
        onMouseEnter={this.onHover.bind(this)}
      >
        <Layout {...this.props} type="YoutubeView" />
        {this.state.hover && <DivHelp>Content</DivHelp>}
      </DivHover>
    );
  }
}

YoutubeView.propTypes = {
  childOf: PropTypes.string,
  values: PropTypes.object,
  cell: PropTypes.array,
  layout: PropTypes.func
};
YoutubeView.defaultProps = {
  childOf: "Content",
  values: {
    parent: "Content",
    type: "YoutubeView",
    containerPadding: "0px",
    videoId: "R0h9qvX2Wy0",
    fullwidth: true,
    alignValue: "center"
  },
  layout: Layout11
};
export default YoutubeView;



// WEBPACK FOOTER //
// ./src/editor/layout/components/Content/YoutubeView.js